<template>
  <v-card
    class="px-4 py-2 rounded-xl"
    outlined
    tile
    :style="{ borderColor: '#F0F0F0' }"
  >
    <v-row align="center" no-gutters>
      <v-col cols="auto" class="mr-4">
        <v-avatar
          size="80"
          :color="!paymentDetail?.file_logo_url ? '#E0E0E0' : ''"
        >
          <template v-if="paymentDetail?.file_logo_url">
            <img :src="paymentDetail.file_logo_url" alt="Bank Logo" />
          </template>
          <template v-else>
            <v-icon size="36" color="#757575">mdi-bank-outline</v-icon>
          </template>
        </v-avatar>
      </v-col>
      <v-col>
        <p class="font-weight-bold mb-1 mt-2">
          {{ paymentDetail?.bank_th }}
        </p>
        <p class="font-weight-bold mb-1">
          เลขที่บัญชี:
          <span>{{ paymentDetail?.bank_account_no || "" }}</span>
        </p>
        <p class="text--secondary">
          ชื่อบัญชี: {{ paymentDetail?.bank_account_name || "" }}
        </p>
      </v-col>
      <v-col cols="auto" class="ml-auto">
        <v-btn
          color="#36B48A"
          outlined
          style="border-radius: 16px"
          @click.stop="$emit('view-detail')"
        >
          ดูรายละเอียด
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "PaymentDetailComponent",
  props: {
    paymentDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasPaymentData() {
      return (
        this.paymentDetail &&
        (this.paymentDetail.bank_id ||
          this.paymentDetail.bank_account_no ||
          this.paymentDetail.bank_account_name)
      );
    },
  },
};
</script>

<style scoped>
.font-weight-medium {
  font-weight: 500;
}
</style>
